import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../services/api';

const ForgotPassword = () => {
  const [step, setStep] = useState(1); // 1 = enter email, 2 = answer + new password
  const [email, setEmail] = useState('');
  const [securityQuestion, setSecurityQuestion] = useState('');
  const [securityAnswer, setSecurityAnswer] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const navigate = useNavigate();

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.get(`/api/auth/security-question/${encodeURIComponent(email)}`);
      setSecurityQuestion(res.data.security_question);
      setStep(2);
    } catch (err) {
      setError(err.response?.data?.error || 'No security question found for this email.');
    } finally {
      setLoading(false);
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) return setError('Passwords do not match');
    if (newPassword.length < 8) return setError('Password must be at least 8 characters');
    setLoading(true);
    try {
      await api.post('/api/auth/reset-password', {
        email,
        security_answer: securityAnswer,
        new_password: newPassword,
      });
      setSuccess(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.error || 'Password reset failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const cardStyle = {
    width: '100%', maxWidth: 420,
    background: 'white', borderRadius: 16, padding: '2.5rem',
    boxShadow: '0 4px 24px rgba(0,0,0,0.08)', border: '1px solid #f0f0f0',
  };

  const logoBlock = (
    <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
      <img src="/TournNextTeal-WithoutTagline.svg" alt="TournNext" style={{ height: 32, width: 'auto', marginBottom: '1.25rem', display: 'block', margin: '0 auto 1.25rem' }} />
      <h2 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#111827', margin: 0 }}>
        Reset password
      </h2>
    </div>
  );

  if (success) {
    return (
      <div style={{ minHeight: 'calc(100vh - 56px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '2rem 1rem', background: 'linear-gradient(160deg, #f0fdfa 0%, #CCFBF1 50%, #f8fafc 100%)' }}>
        <div style={cardStyle}>
          {logoBlock}
          <div className="alert" style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', color: '#166534', borderRadius: 8, padding: '1rem', textAlign: 'center' }}>
            Password reset successful! Redirecting to login...
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: 'calc(100vh - 56px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '2rem 1rem',
        background: 'linear-gradient(160deg, #f0fdfa 0%, #CCFBF1 50%, #f8fafc 100%)',
      }}
    >
      <div style={cardStyle}>
        {logoBlock}

        {error && <div className="alert alert-error">{error}</div>}

        {step === 1 && (
          <form onSubmit={handleEmailSubmit}>
            <p style={{ color: '#6b7280', fontSize: '0.875rem', marginBottom: '1.25rem' }}>
              Enter your registered email address and we'll show your security question.
            </p>
            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                type="email" className="form-input" value={email}
                onChange={e => setEmail(e.target.value)} required placeholder="you@example.com"
              />
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '10px' }} disabled={loading}>
              {loading ? 'Looking up...' : 'Continue'}
            </button>
          </form>
        )}

        {step === 2 && (
          <form onSubmit={handleResetSubmit}>
            <div className="form-group">
              <label className="form-label">Security Question</label>
              <p style={{ fontWeight: 500, color: '#374151', margin: '4px 0 0' }}>{securityQuestion}</p>
            </div>
            <div className="form-group">
              <label className="form-label">Your Answer</label>
              <input
                type="text" className="form-input" value={securityAnswer}
                onChange={e => setSecurityAnswer(e.target.value)} required placeholder="Your answer" autoComplete="off"
              />
            </div>
            <div className="grid grid-2">
              <div className="form-group">
                <label className="form-label">New Password</label>
                <input type="password" className="form-input" value={newPassword} onChange={e => setNewPassword(e.target.value)} required placeholder="Min 8 characters" minLength={8} />
              </div>
              <div className="form-group">
                <label className="form-label">Confirm Password</label>
                <input type="password" className="form-input" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required placeholder="Repeat password" />
              </div>
            </div>
            <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '10px' }} disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
            <button type="button" className="btn" style={{ width: '100%', marginTop: '0.5rem' }} onClick={() => { setStep(1); setError(''); }}>
              Back
            </button>
          </form>
        )}

        <p style={{ textAlign: 'center', marginTop: '1.25rem', color: '#6b7280', fontSize: '0.875rem' }}>
          Remember your password?{' '}
          <Link to="/login" style={{ color: '#0D9488', fontWeight: 500, textDecoration: 'none' }}>
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ForgotPassword;
